import React from "react";
import { Typography, Box, styled } from "@mui/material";
import CloseIcon from "src/icons/CloseIcon";
import StepProgress from "./StepProgress";
import HyroLogo from "src/layout/Logos/HyroLogo";
import hyroLogo from "src/static/images/logo.svg";
import { HyroIconButton } from "@hyro-components";
import { ICON_BUTTON_VARIANTS, ICON_BUTTON_SIZES } from "@hyro-components/hyro-icon-button/HyroIconButton.consts";

const StepperHeader = ({ heading, handleCancel, hideProgress, activeStep, steps, showLogo, closeDisabled }) =>
  <StyledHeader showBorder={steps.length > 1 && !hideProgress}>
    {showLogo && <HyroLogo src={hyroLogo} />}

    {hideProgress ? <Box mt={4} /> :
      <StepProgress numSteps={steps.length} activeStep={activeStep} steps={steps} />}

    {!!heading && <Typography variant='h5' textAlign='center' mt={"36px"}>
      {heading}
    </Typography>}

    <HyroIconButton data-testid="hyro-stepper-dialog-close-button" variant={ICON_BUTTON_VARIANTS.CLEAR} size={ICON_BUTTON_SIZES.LARGE} onClick={handleCancel} disabled={closeDisabled}>
      <CloseIcon />
    </HyroIconButton>
  </StyledHeader>;

export default StepperHeader;

const StyledHeader = styled(Box, {
  shouldForwardProp: (prop) => prop !== "showBorder"
})(({ showBorder }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  borderBottom: showBorder ? "1px solid " + (theme => theme.palette.grey[300]) : "none",
  padding: "14px 16px"
}));
